import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { hasClass, removeCss, toggleClass } from '@shared/easyfy.utils';

@invoke
export default class CountrySelector {
  private cssClass: string = 'expanded';
  private countryList: HTMLElement;

  constructor() {}
  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'toggle-countries',
          callback: this.showCountries,
        },
      ],
    });
  }

  showCountries = (e: Event) => {
    e.stopPropagation();

    const target = e.target as HTMLElement;
    this.countryList = target.parentElement?.querySelector<HTMLElement>('[data-container="country-list"]');
    if (!this.countryList) return;

    toggleClass(this.countryList, this.cssClass);

    if (hasClass(this.countryList, this.cssClass)) {
      document.addEventListener('click', this.closeOnEvent);
      document.addEventListener('scroll', this.closeOnEvent);
    }
  };

  closeOnEvent = (e: Event) => {
    const target = e.target as HTMLElement;

    if (e.type === 'click' && this.countryList.contains(target)) return;

    removeCss(this.countryList, this.cssClass);
    this.countryList = null;
    this.removeEventListeners();
  };

  removeEventListeners = () => {
    document.removeEventListener('click', this.closeOnEvent);
    document.removeEventListener('scroll', this.closeOnEvent);
  };
}
